import { inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

export function injectId(): string {
  return injectParam("id");
}

export function injectUuid(): string {
  return injectParam("uuid");
}

export function injectParam<T = string>(param: string): T {
  return <T>inject(ActivatedRoute).snapshot.params[param];
}

export function injectQueryParam(queryParam: string): string | undefined {
  return inject(ActivatedRoute).snapshot.queryParams[queryParam];
}
